import './styles.scss';
import {
    IconAlphabetLatin, IconHash, IconPhone, IconMail, IconUser, IconLink,
    IconChevronDown, IconListCheck, IconToggleRight, IconGauge,
    IconCalendar, IconCalendarTime, IconCoin, IconPhoto, IconVideo,
    IconBarbell, IconGenderBigender, IconRun,
} from '@tabler/icons-react';
import FormConfig from './components/FormConfig';
import StepConfig from './components/StepConfig';

export const QUESTION_TYPES = [
    { type: 'text', label: 'Texto curto', Icon: IconAlphabetLatin, defaultLabel: '' },
    { type: 'full_name', label: 'Nome completo', Icon: IconUser, defaultLabel: 'Qual é o seu nome completo?' },
    { type: 'email', label: 'E-mail', Icon: IconMail, defaultLabel: 'Qual é o seu e-mail?' },
    { type: 'phone', label: 'Telefone', Icon: IconPhone, defaultLabel: 'Qual é o seu número de telefone?' },
    { type: 'number', label: 'Número', Icon: IconHash, defaultLabel: '' },
    { type: 'url', label: 'URL / Link', Icon: IconLink, defaultLabel: '' },
    { type: 'select', label: 'Seleção única', Icon: IconChevronDown, defaultLabel: '', hidden: true },
    { type: 'choices', label: 'Múltipla escolha', Icon: IconListCheck, defaultLabel: '' },
    { type: 'yes_no_maybe', label: 'Sim / Não', Icon: IconToggleRight, defaultLabel: '' },
    { type: 'scale', label: 'Escala', Icon: IconGauge, defaultLabel: '' },
    { type: 'date', label: 'Data', Icon: IconCalendar, defaultLabel: 'Insira uma data' },
    { type: 'datetime', label: 'Data e hora', Icon: IconCalendarTime, defaultLabel: '' },
    { type: 'monetary', label: 'Valor monetário', Icon: IconCoin, defaultLabel: '' },
    { type: 'photo', label: 'Foto', Icon: IconPhoto, defaultLabel: 'Envie uma foto do seu progresso', comingSoon: true },
    { type: 'video', label: 'Vídeo', Icon: IconVideo, defaultLabel: 'Envie um vídeo de apresentação', comingSoon: true },
    { type: 'weight', label: 'Peso', Icon: IconBarbell, defaultLabel: 'Qual é o seu peso atual?' },
    { type: 'gender', label: 'Gênero', Icon: IconGenderBigender, defaultLabel: 'Como você se identifica?' },
    { type: 'body_structure', label: 'Biotipo', Icon: IconRun, defaultLabel: 'Qual é o seu biotipo?' },
];

export default function RightPanel({
    selectedStep, stepNumber, updateStep,
    addQuestion, updateQuestion, removeQuestion, reorderQuestions,
    onDeselect,
    communityId,
    formName, setFormName, formActive, setFormActive,
    redirectChoice, setRedirectChoice,
    returnUrl, setReturnUrl,
    allowMultipleAnswers, setAllowMultipleAnswers,
    banner, setBanner,
    theme, setTheme,
    actions, addAction, removeAction,
    errors, clearError,
    scrollSignal,
}) {
    const formErrors = errors?.form ?? {};
    const stepErrors = selectedStep ? (errors?.steps?.[selectedStep.id] ?? {}) : {};

    if (!selectedStep) {
        return (
            <FormConfig
                communityId={communityId}
                formName={formName}
                setFormName={setFormName}
                formActive={formActive}
                setFormActive={setFormActive}
                redirectChoice={redirectChoice}
                setRedirectChoice={setRedirectChoice}
                allowMultipleAnswers={allowMultipleAnswers}
                setAllowMultipleAnswers={setAllowMultipleAnswers}
                returnUrl={returnUrl}
                setReturnUrl={setReturnUrl}
                banner={banner}
                setBanner={setBanner}
                theme={theme}
                setTheme={setTheme}
                actions={actions}
                addAction={addAction}
                removeAction={removeAction}
                formErrors={formErrors}
                clearError={clearError}
                scrollSignal={scrollSignal}
            />
        );
    }

    return (
        <StepConfig
            selectedStep={selectedStep}
            stepNumber={stepNumber}
            updateStep={updateStep}
            addQuestion={addQuestion}
            updateQuestion={updateQuestion}
            removeQuestion={removeQuestion}
            reorderQuestions={reorderQuestions}
            onDeselect={onDeselect}
            stepErrors={stepErrors}
            clearError={clearError}
            scrollSignal={scrollSignal}
        />
    );
}
